import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import MenuButton from '../../app/styles/components/MenuButton'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import CustomerObj from './customerObj';
import { selectCustomer } from './customerSlice';

const CLIENT_ID = process.env.REACT_APP_IDME_CLIENT_ID;
const getRedirectUri = () => {
    const origin = window.location.origin;

    if (origin.includes('localhost')) {
        return 'http://localhost:3000/idme/callback';
    } else if (origin.includes('emmstaging')) {
        return 'https://shop.emmstaging.com/idme/callback';
    } else {
        return 'https://www.mightymeals.com/idme/callback';
    }
};

const REDIRECT_URI = getRedirectUri();

export default function SupportHelpMobile() {
    const customer = new CustomerObj(useSelector(selectCustomer));
    const idmeAuthUrl = `https://groups.id.me/?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&response_type=code&&scope=military,responder`;

    return (
        <Container fluid="lg" className='my-2'>
            <Row>
                <Col xs={1} className='p-0 px-2 pt-2'>
                    <MenuButton />
                </Col>
                <Col xs={11} className='p-0 px-3 d-flex align-items-center justify-content-end'>
                    <span className="text-uppercase fw-400 fs-32px font-league-gothic">SUPPORT & HELP</span>
                </Col>
                <Col xs={4} className='p-0'>
                    <Button
                        as={Link as any}
                        to={`https://mightymeals.freshdesk.com/support/tickets/new`}
                        target='_blank'
                        variant="white"
                        size="lg"
                        className={`text-uppercase fs-15px font-glegoo myaccountbox d-flex flex-column align-items-center justify-content-center text-white p-2`}
                    >
                        SUBMIT SUPPORT TICKET
                    </Button>
                </Col>
                <Col xs={4} className='p-0'>
                    <Button
                        as={Link as any}
                        to={`https://mightymeals.freshdesk.com/support/tickets/new`}
                        target='_blank'
                        variant="white"
                        size="lg"
                        className={`text-uppercase fs-15px font-glegoo myaccountbox d-flex flex-column align-items-center justify-content-center text-white p-2`}
                    >
                        REFUND REQUESTS
                    </Button>
                </Col>
                <Col xs={4} className='p-0'>
                    <Button
                        as={Link as any}
                        to={`https://mightymeals.freshdesk.com/support/tickets/new`}
                        target='_blank'
                        variant="white"
                        size="lg"
                        className={`text-uppercase fs-15px font-glegoo myaccountbox d-flex flex-column align-items-center justify-content-center text-white p-2`}
                    >
                        REQUEST DELIVERY DATE CHANGE
                    </Button>
                </Col>
                {!customer.hasMembership() &&
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`https://mightymeals.freshdesk.com/support/tickets/new`}
                            target='_blank'
                            variant="white"
                            size="lg"
                            className={`text-uppercase fs-15px font-glegoo myaccountbox d-flex flex-column align-items-center justify-content-center text-white p-2`}
                        >
                            VERIFY MILITARY DISCOUNT
                        </Button>
                    </Col>}
            </Row>
        </Container>
    )
}